import { render } from "./CardTemplate.vue?vue&type=template&id=72449620&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=72449620&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72449620"

export default script